window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Dynamic baseURL for Axios requests based on subfolder (/react, /react/public, /react-app)
const pathName = window.location.pathname;
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
if (isProduction) {
    if (pathName.startsWith('/react/public')) {
        window.axios.defaults.baseURL = '/react/public';
    } else if (pathName.startsWith('/react-app')) {
        window.axios.defaults.baseURL = '/react-app';
    } else if (pathName.startsWith('/react')) {
        window.axios.defaults.baseURL = '/react';
    }
}

// Intercept native fetch calls to prepend subfolder path for /api calls
const originalFetch = window.fetch;
window.fetch = function (url, options) {
    if (typeof url === 'string' && url.startsWith('/api')) {
        const pName = window.location.pathname;
        if (isProduction) {
            if (pName.startsWith('/react/public')) {
                url = `/react/public${url}`;
            } else if (pName.startsWith('/react-app')) {
                url = `/react-app${url}`;
            } else if (pName.startsWith('/react')) {
                url = `/react${url}`;
            }
        }
    }
    return originalFetch.call(this, url, options);
};

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
